import { gqlRequest, type RequestSession } from './api/client'
import type { PackingLabels } from './configuration'
import { PrinterJobMutation } from './printing'
import type { Slip } from './slips'

// JSON strings are valid Typst strings. Render names through #text so product text
// cannot inject Typst markup, imports, or executable expressions.
export function labelSource(name: string, orderCode: string, alternatives: string[], width: number, height: number) {
  return `#set page(width: ${width}mm, height: ${height}mm, margin: 3mm)\n#set text(size: 11pt)\n#text(weight: "bold", ${JSON.stringify(orderCode)})\n#parbreak()\n#text(weight: "bold", ${JSON.stringify(name)})\n#parbreak()\n#text(size: 9pt, ${JSON.stringify(alternatives.join(', '))})`
}
export async function printLabels(session: RequestSession, restaurantId: string, displayId: string, slip: Slip, config: PackingLabels) {
  if (!config.enabled) return
  const queue = config.printerQueueId
  if (!queue) throw new Error('Ingen etikettskrivare konfigurerad')
  const permittedChannel = config.channels.includes(slip.transactionChannel ?? '') || config.channels.includes(slip.orderType ?? '')
  for (const section of slip.lineItemSections ?? []) {
    if (!section || section.isSecondary) continue
    for (const item of section.items ?? []) {
      if (!item?.productId) continue
      const always = config.alwaysPrintProductIds.includes(item.productId)
      if (!always && (!permittedChannel || !config.productIds.includes(item.productId))) continue
      for (let copy = 0; copy < Math.ceil(item.count ?? 1); copy++) {
        await gqlRequest(session, PrinterJobMutation, {
          restaurantId,
          input: {
            idempotencyKey: `galley.label/${slip.id}/${displayId}/${item.id}/${copy}`,
            printerQueueId: queue,
            typst: labelSource(
              item.name ?? '',
              slip.humanOrderCode ?? '',
              (item.alternativeItems ?? []).flatMap((option) => (option?.isChosen === false ? [] : option?.name ? [option.name] : [])),
              config.widthMm,
              config.heightMm,
            ),
          },
        })
      }
    }
  }
}
